import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { isAdminNotConsultant, isIndividual, isHorecaOrWholesalerOrHoldingUs, isUserBuyerGroup, isConsultantNotHolding } from "@/js/http/auth.js";
import { filterVAutocomplete } from "@/js/forms.js";
import { bottlings, listWineRangeAccessibility, COMPARISON_OPERATORS } from "@/js/lists.ts";
var defaultOptions = {
  smoothScroll: true
};
export default {
  name: "SpiritsFilters",
  props: {
    loggedUserData: Object,
    filters: Object,
    storageLocations: Array,
    producers: Array,
    appellations: Array,
    listCountries: Array,
    listRegions: Array,
    hasAnySpecialDeal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      options: {},
      openedCollapses: [],
      boolRenderLinkedCheckbox: false,
      isAllowedToFilterLocation: false,
      displayedListRegions: [],
      displayedListDistilleries: [],
      displayedListAppellations: [],
      displayedListDenominations: [],
      minPrice: 0,
      isFiltering: false,
      comparisonOperators: Object.values(COMPARISON_OPERATORS),
      bottlings: bottlings,
      listWineRangeAccessibility: listWineRangeAccessibility
    };
  },
  computed: {
    isPropsHaveBeenTransmitted: function isPropsHaveBeenTransmitted() {
      var _this$producers, _this$appellations, _this$listRegions;
      return ((_this$producers = this.producers) === null || _this$producers === void 0 ? void 0 : _this$producers.length) > 0 && ((_this$appellations = this.appellations) === null || _this$appellations === void 0 ? void 0 : _this$appellations.length) > 0 && ((_this$listRegions = this.listRegions) === null || _this$listRegions === void 0 ? void 0 : _this$listRegions.length) > 0;
    },
    countries: function countries() {
      return _toConsumableArray(new Map(this.listCountries.map(function (item) {
        return [item["id_country"], item];
      })).values());
    },
    filterStockOnlyDefault: function filterStockOnlyDefault() {
      if (isAdminNotConsultant(this.loggedUserData)) {
        return false;
      } else {
        return this.$whitelabel.WineListStockOnlyDefault;
      }
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var isHorecaUsa;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isIndividual(_this.loggedUserData)) {
              _context.next = 5;
              break;
            }
            _context.next = 3;
            return isHorecaOrWholesalerOrHoldingUs(_this.loggedUserData);
          case 3:
            isHorecaUsa = _context.sent;
            _this.isAllowedToFilterLocation = isAdminNotConsultant(_this.loggedUserData) || isConsultantNotHolding(_this.loggedUserData) || isHorecaUsa;
          case 5:
            _this.regenerateDisplayedLists();
            _this.checkIsFiltering();
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    filter: function filter(_, itemText, queryText) {
      var _itemText = String.removeDiacritics(itemText.toLocaleLowerCase());
      var _queryText = String.removeDiacritics(queryText.toLocaleLowerCase());
      return _queryText.indexOf(_itemText) > -1;
    },
    changeStockOnlyFilter: function changeStockOnlyFilter() {
      if (!this.filters.stockOnly) {
        this.filters.stockQuantityMin = null;
        this.filters.warehouseOnly = false;
        this.filters.departureContinent = null;
      }
      this.boolRenderLinkedCheckbox = !this.boolRenderLinkedCheckbox;
      this.filtersChanged();
    },
    changeWarehouseOnlyFilter: function changeWarehouseOnlyFilter() {
      if (this.filters.warehouseOnly) {
        this.filters.stockOnly = true;
      }
      this.boolRenderLinkedCheckbox = !this.boolRenderLinkedCheckbox;
      this.filtersChanged();
    },
    filtersChanged: function filtersChanged() {
      this.cleanFilters();
      this.checkIsFiltering();
      this.$emit("filtersChanged", _objectSpread(_objectSpread({}, defaultOptions), this.options));
    },
    cleanFilters: function cleanFilters() {
      var _this$filters$appella, _this$filters$denomin;
      if (!!this.filters.producer) {
        var idsAvailable = this.displayedListDistilleries.map(function (x) {
          return x.id;
        });
        if (!idsAvailable.includes(this.filters.producer)) {
          this.filters.producer = null;
        }
      }
      if (!!this.filters.region) {
        var _idsAvailable = this.displayedListRegions.map(function (x) {
          return x.id;
        });
        if (!_idsAvailable.includes(this.filters.region)) {
          this.filters.region = null;
        }
      }
      if (!!((_this$filters$appella = this.filters.appellation) !== null && _this$filters$appella !== void 0 && _this$filters$appella.id_appellation)) {
        var _idsAvailable2 = this.displayedListAppellations.map(function (x) {
          return x.id_appellation;
        });
        if (!_idsAvailable2.includes(this.filters.appellation.id_appellation)) {
          this.filters.appellation = null;
        }
      }
      if (!!((_this$filters$denomin = this.filters.denomination) !== null && _this$filters$denomin !== void 0 && _this$filters$denomin.id_appellation)) {
        var _idsAvailable3 = this.displayedListDenominations.map(function (x) {
          return x.id_appellation;
        });
        if (!_idsAvailable3.includes(this.filters.denomination.id_appellation)) {
          this.filters.denomination = null;
        }
      } else {
        this.filters.denomination = null;
      }
    },
    clearFilters: function clearFilters() {
      var _this2 = this;
      this.filters.stockOnly = this.filterStockOnlyDefault;
      this.changeStockOnlyFilter();
      this.filters.bottling = null;
      this.filters.vintage = null;
      this.filters.vintageCmpOp = "=";
      this.filters.country = null;
      this.filters.region = null;
      this.filters.appellation = null;
      this.filters.denomination = null;
      this.filters.producer = null;
      this.filters.rangeAccessibilities = null;
      this.regenerateDisplayedLists();
      this.boolRenderLinkedCheckbox = !this.boolRenderLinkedCheckbox;
      this.$nextTick(function () {
        return _this2.filtersChanged();
      });
    },
    checkIsFiltering: function checkIsFiltering() {
      var _this$filters$bottlin, _this$filters$rangeAc, _this$filters$vintage, _this$filters$stockQu;
      var isStockOnly = this.filters.stockOnly === "true" || this.filters.stockOnly === true;
      this.isFiltering = ((_this$filters$bottlin = this.filters.bottling) === null || _this$filters$bottlin === void 0 ? void 0 : _this$filters$bottlin.length) > 0 || !!this.filters.departureContinent || !!((_this$filters$rangeAc = this.filters.rangeAccessibilities) !== null && _this$filters$rangeAc !== void 0 && _this$filters$rangeAc.length) > 0 || !!this.filters.producer || ((_this$filters$vintage = this.filters.vintage) === null || _this$filters$vintage === void 0 ? void 0 : _this$filters$vintage.length) > 0 || ((_this$filters$stockQu = this.filters.stockQuantityMin) === null || _this$filters$stockQu === void 0 ? void 0 : _this$filters$stockQu.length) > 0 || !!this.filters.appellation || !!this.filters.country || !!this.filters.specialDealsOnly || isStockOnly !== this.filterStockOnlyDefault;
    },
    changeCountry: function changeCountry() {
      this.filters.region = null;
      this.regenerateDisplayedLists();
      this.filtersChanged();
    },
    changeRegion: function changeRegion() {
      this.regenerateDisplayedLists();
      this.filtersChanged();
    },
    changeAppellation: function changeAppellation() {
      this.filters.denomination = null;
      this.regenerateDisplayedLists();
      this.filtersChanged();
    },
    regenerateDisplayedLists: function regenerateDisplayedLists() {
      this.generateRegionsList();
      this.generateDistilleriesList();
      this.generateAppellationsList();
      this.generateDenominationsList();
    },
    generateRegionsList: function generateRegionsList() {
      var _this3 = this;
      this.displayedListRegions = [];
      if (this.filters.country) {
        this.displayedListRegions = _toConsumableArray(this.listRegions.filter(function (region) {
          return region.country.id_country === _this3.filters.country && region.isSpiritRegion === true;
        }));
      }
    },
    generateDistilleriesList: function generateDistilleriesList() {
      var _this4 = this;
      if (!!this.filters.country) {
        if (!!this.filters.region) {
          this.displayedListDistilleries = _toConsumableArray(this.producers.filter(function (x) {
            return x.regionSubs.some(function (sub) {
              return sub.regionParent.country.id_country == _this4.filters.country && sub.regionParent.id == _this4.filters.region;
            }) && x.isDistillery === true;
          }));
        } else {
          this.displayedListDistilleries = _toConsumableArray(this.producers.filter(function (x) {
            return x.regionSubs.some(function (sub) {
              return sub.regionParent.country.id_country == _this4.filters.country;
            }) && x.isDistillery === true;
          }));
        }
      } else {
        this.displayedListDistilleries = _toConsumableArray(this.producers.filter(function (x) {
          return x.isDistillery === true;
        }));
      }
    },
    generateAppellationsList: function generateAppellationsList() {
      var _this5 = this;
      if (!!this.filters.country) {
        if (!!this.filters.region) {
          this.displayedListAppellations = _toConsumableArray(this.appellations.filter(function (x) {
            return x.region.country.id_country == _this5.filters.country && x.region.id == _this5.filters.region && x.isSpirit === true;
          }));
        } else {
          this.displayedListAppellations = _toConsumableArray(this.appellations.filter(function (x) {
            return x.region.country.id_country == _this5.filters.country && x.isSpirit === true;
          }));
        }
      } else {
        this.displayedListAppellations = _toConsumableArray(this.appellations.filter(function (x) {
          return x.isSpirit === true;
        }));
      }
    },
    generateDenominationsList: function generateDenominationsList() {
      this.displayedListDenominations = [];
      if (!!this.filters.appellation) {
        this.displayedListDenominations = _toConsumableArray(this.filters.appellation.denominations);
      }
    },
    filterVAutocomplete: filterVAutocomplete,
    isAdminNotConsultant: isAdminNotConsultant,
    isUserBuyerGroup: isUserBuyerGroup,
    isIndividual: isIndividual
  },
  watch: {
    isPropsHaveBeenTransmitted: function isPropsHaveBeenTransmitted(newVal, oldVal) {
      if (newVal) this.regenerateDisplayedLists();
    }
  }
};